import $ from 'jquery';
import slick from  '../vendors/slider.min';

class BjzmScripts {
	
	constructor() {
		 this.do_hamburger();
		 this.doSliders();
		 this.isHamburgerOpen = false;
		 this.setTouchScreenClasses(".button, .navigation__link");
		 this.mobileHeader = $(".header--mobile");
		 this.doQuoteSlider();
		}



	doQuoteSlider() {
		$(".quote-slides").slick({
			prevArrow: $('.test-nav__left'),
			nextArrow: $('.test-nav__right'),
	        autoplaySpeed: 5000,
	        infinite: true,
	        autoplay: true,
            pauseOnHover: true
		});
		$(".quote-slides").on('beforeChange', (event, slick, currentSlide, nextSlide, sliderId, sliderType) => {
			var slideIndex = nextSlide + 1;
			var i = (nextSlide ? nextSlide : 0) + 1;
			$(`.test-section--count__current`).addClass('go-out');
			setTimeout(function(){
				$(`.test-section--count__current`).removeClass('go-out');
				$(`.test-section--count__current`).addClass('go-in');
				$(`.test-section--count__current`).html(`<p>${i}</p>`);
			}, 300);
			setTimeout(function(){
				$(`.test-section--count__current`).removeClass('go-out');
				$(`.test-section--count__current`).addClass('go-in');
				$(`.test-section--count__current`).html(`<p>${i}</p>`);
			}, 700);
		} );
	}

	do_hamburger() {
		var self = this;
		$(".hamburger__inner").click(function(e){
			e.preventDefault();
			if( self.isHamburgerOpen ) {
				self.closeMobileMenu();
			}
			else {
				self.openMobileMenu();
			}
		})
	}

	doSliders() {
		if( $(".bjzm-slideshow__list").length > 0 ) {
			
			$(".bjzm-slideshow__list").slick({ 
				dots: false,
				centerPadding: '20px',
		 		slidesToShow: 1,
		 		variableWidth: true,
		 		adaptiveHeight: true,
		 		arrows: false,
	            dotsClass: 'custom_paging',
	            useCSS: true,
	            centerMode: true,
	            cssEase: 'ease-in-out'
		 	});
			$(".bjzm-slideshow__nav-link--prev").on('click', function(e){
				e.preventDefault();
				$(".bjzm-slideshow__list").slick('slickPrev');
			})
			$(".bjzm-slideshow__nav-link--next").on('click', function(e){
				e.preventDefault();
				$(".bjzm-slideshow__list").slick('slickNext');
			});

		} 	
	}

	openMobileMenu() {
		this.mobileHeader.addClass("header--mobile-menu-active");
		$('body').addClass("scroll-lock");
		this.isHamburgerOpen = true;
	}

	closeMobileMenu() {
		this.mobileHeader.removeClass("header--mobile-menu-active");
		$('body').removeClass("scroll-lock");
		this.isHamburgerOpen = false;
	}


	is_touch_device() {
		return (('ontouchstart' in window)
			|| (navigator.MaxTouchPoints > 0)
			|| (navigator.msMaxTouchPoints > 0));
	}

	getTouchClass() {
		return ( this.is_touch_device() ) ? ' touch-screen' : ' desktop-screen';
	}

	setTouchScreenClasses(selectors) {

		var classes = this.getTouchClass();
		$(selectors).addClass( classes );
	}

	

	
}

module.exports = BjzmScripts;